import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import GetInTouchWithSamBrandingMarketing from "./sections/GetInTouchWithSamBrandingMarketing";
import ContactInformation from "./sections/ContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <GetInTouchWithSamBrandingMarketing />
      <ContactInformation />
      <Footer />
    </div>;
}